<template>
  <article id="apt-wrapper" class="contents-wrapper">
    <router-view />
  </article>
</template>

<script lang="ts">
// import * as api from "@/api";
// import HoonyNavigation from "@/common/components/HoonyNavigation.vue";
// import { PageResponse } from "@/common/class/PageSearchRequest";
export default {
  setup() {
    return {};
  },
  data() {
    return {
      title: "",
    };
  },
  // components: { HoonyNavigation },
  methods: {
    helloWorld() {
      console.log("helloWorld!");
    },
  },
  created() {
    console.log("[InstaWrapper] created");
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
